import CSSPlugin from 'gsapAlias/CSSPlugin'
import { Power1 } from 'gsapAlias/EasePack'
import TimelineLite from 'gsapAlias/TimelineLite'
import TweenLite from 'gsapAlias/TweenLite'

// eslint-disable-next-line no-unused-vars
const plugins = [CSSPlugin]

export const fadeOutBlock = ({ node }) => {
  return TweenLite.fromTo(node, 1, { alpha: 1 }, { alpha: 0 })
}

export const timeline = ({ wgsBar, wgsBox, dnaBar, dnaBox }) => {
  const tl = new TimelineLite({ paused: true })

  tl.add([
    TweenLite.to(wgsBar.current, 0.9, { height: '100%', ease: Power1.easeOut }),
    TweenLite.to(wgsBox.current, 0.6, { alpha: 1, y: 0 }).delay(-0.3),
    TweenLite.to(dnaBar.current, 0.9, { height: '100%', ease: Power1.easeOut }),
    TweenLite.to(dnaBox.current, 0.6, { alpha: 1, y: 0 }).delay(-0.3),
  ])

  return tl
}
